module.exports = __webpack_public_path__ + "img/doc-success.7776f5a2.png";